import React from 'react';

import { Outlet } from 'react-router-dom';

import Header from './Header/Header';
import styles from './MainLayout.module.scss';
import Footer from './Footer/Footer';
import GlobalModals from './GlobalModals/GlobalModals';

const MainLayout = () => {
  return (
    <div className={styles.mainLayout}>
      <Header />
      <div className={styles.mainWrapper}>
        <div className={styles.main}>
          <Outlet />
          <GlobalModals />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
